import { render, staticRenderFns } from "./yyyd.vue?vue&type=template&id=b2f33d02&"
import script from "./yyyd.vue?vue&type=script&lang=js&"
export * from "./yyyd.vue?vue&type=script&lang=js&"
import style0 from "./yyyd.vue?vue&type=style&index=0&id=b2f33d02&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports